'use client'

import Layout from '@/components/templates/layout'
import Cover from './components/cover'
import Banner from './components/banner'
import Quote from './components/quote'
import AboutUs from './components/aboutUs'
import CTACard from './components/ctaCard'
import Facilities from './components/facilities'
import ImageSpacer from './components/imageSpacer'
import Events from './components/events'
import Instagram from './components/instagram'
import Community from '@/components/organisms/community'

const HomePage = ({ homeAPI, footerAPI, settingAPI }) => {
  return (
    <Layout settingAPI={settingAPI} footerAPI={footerAPI}>
      <Cover
        option={homeAPI.cover.option}
        image={homeAPI.cover.image}
        imagePlaceholder={homeAPI.cover.imagePlaceholder}
        video={homeAPI.cover.video}
      />
      {!homeAPI.hideBanner ? (
        <Banner
          imageDesktop={homeAPI.banner.desktop}
          imageMobile={homeAPI.banner.mobile}
        />
      ) : (
        <></>
      )}
      <Quote quote={homeAPI.quote} />
      <AboutUs
        description={homeAPI.about.description}
        imageSmall={homeAPI.about.imageSmall}
        imageBig={homeAPI.about.imageBig}
      />
      <CTACard
        titleRow1={homeAPI.booking.title.row1}
        titleRow2={homeAPI.booking.title.row2}
        description={homeAPI.booking.description}
        buttonName={homeAPI.booking.ctaButton.name}
        link={homeAPI.booking.ctaButton.link}
        bottomSpacer={false}
        className="mt-largeMobile lg:mt-largeDesktop"
      />
      <CTACard
        titleRow1={homeAPI.membership.title.row1}
        titleRow2={homeAPI.membership.title.row2}
        description={homeAPI.membership.description}
        buttonName={homeAPI.membership.ctaButton.name}
        link={homeAPI.membership.ctaButton.link}
      />
      <Facilities
        description={homeAPI.facilities.description}
        imageSmall={homeAPI.facilities.imageSmall}
        imageBig={homeAPI.facilities.imageBig}
        ctaButton={homeAPI.facilities.ctaButton}
      />
      <ImageSpacer image={homeAPI.imageSpacer} />
      {homeAPI.events.highlights?.length > 0 && !homeAPI.hideEvents && !settingAPI.hideEventsPage ? (
        <Events events={homeAPI.events} />
      ) : (
        <></>
      )}
      <Community
        title={settingAPI.community.title}
        description={settingAPI.community.description}
        image={settingAPI.community.image}
        ctaButton={settingAPI.community.ctaButton}
      />
      <Instagram
        title={homeAPI.instagram.title}
        elfsightID={homeAPI.instagram.elfsightID}
        link={homeAPI.instagram.link}
      />
    </Layout>
  )
}

export default HomePage
